import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { Shield, Award, Users, Ruler, ArrowRight } from "lucide-react";
import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;

export default function About() {
  const [about, setAbout] = useState(null);

  useEffect(() => {
    axios.get(`${API}/api/about`).then((r) => setAbout(r.data)).catch(() => {});
  }, []);

  if (!about) return null;

  const stats = [
    { icon: Shield, value: about.stat_years, label: "Yıllık Deneyim" },
    { icon: Award, value: about.stat_projects, label: "Tamamlanan Proje" },
    { icon: Users, value: about.stat_clients, label: "Mutlu Müşteri" },
    { icon: Ruler, value: about.stat_area, label: "m² İnşaat Alanı" },
  ];

  return (
    <section id="hakkimizda" data-testid="about-section" className="py-20 sm:py-28 bg-[#F9FAFB]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-12">
        <motion.div initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-20">
          {stats.map((s, i) => (
            <div key={i} className="stat-item bg-white rounded-2xl shadow-sm border border-gray-100" data-testid={`stat-${i}`}>
              <s.icon size={22} className="mx-auto mb-3 text-[#FF5A00]" strokeWidth={1.5} />
              <p className="stat-value">{s.value}</p>
              <p className="text-sm text-gray-500 mt-2 font-medium">{s.label}</p>
            </div>
          ))}
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <p className="overline mb-5">Hakkımızda</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tighter text-[#0C0C0C] leading-tight mb-6" style={{ fontFamily: "Outfit" }}>
              {about.title.split(" ").slice(0, 2).join(" ")} <br />
              <span className="text-[#FF5A00]">{about.title.split(" ").slice(2).join(" ")}</span>
            </h2>
            <p className="text-gray-500 leading-relaxed mb-5 text-base">{about.text}</p>
            <p className="text-gray-500 leading-relaxed mb-8 text-base">{about.text2}</p>
            <a href="/projeler" className="btn-modern btn-dark" data-testid="about-cta">
              Projelerimizi Keşfedin <ArrowRight size={16} />
            </a>
          </motion.div>

          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.2 }} className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img src={about.image} alt="Construction" className="w-full h-[400px] lg:h-[500px] object-cover" loading="lazy" />
            </div>
            <div className="absolute -bottom-6 -left-4 sm:left-6 bg-[#FF5A00] text-white rounded-2xl p-5 shadow-lg animate-float">
              <p className="text-3xl font-bold" style={{ fontFamily: "Outfit" }}>{about.stat_years}</p>
              <p className="text-sm text-white/80">Yıllık Deneyim</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
